import AuditLogTypes from './types';

export const fetchAuditLog = ({
    page,
    size,
    status,
    search,
    timeframe,
}) => ({
    type: AuditLogTypes.FETCH_AUDIT_LOG_START,
    data: { page, size, status, search, timeframe },
});
export const fetchAuditLogSuccess = (auditLog) => ({
    type: AuditLogTypes.FETCH_AUDIT_LOG_SUCCESS,
    payload: auditLog
});
export const fetchAuditLogFailure = (error) => ({
    type: AuditLogTypes.FETCH_AUDIT_LOG_FAILURE,
    payload: error
});
